import CenteredContentLayout from "@/components/layout/CenteredContentLayout";
import { useQuests } from "@/features/quests/api/get-quests";
import { createFileRoute } from "@tanstack/react-router";
import { DailyStreak } from "./-components/DailyStreak";
import HopiumCard from "./-components/Hopium";
import Inventory from "./-components/Inventory";
import Profile from "./-components/Profile";
import Quests from "./-components/Quests";
import Refs from "./-components/Refs";

export const Route = createFileRoute("/_main/dashboard/progress/")({
  head: () => ({
    meta: [{ title: "Reactor | Dashboard" }],
  }),
  component: ProgressPage,
});

function ProgressPage() {
  const { data: questData } = useQuests();

  return (
    <CenteredContentLayout>
      <div className="no-scrollbar flex w-full flex-col gap-3 overflow-y-auto">
        <div className="grid grid-cols-1 gap-1.5 xl:grid-cols-[1fr,1fr]">
          <Profile />
          <div className="grid grid-cols-2 gap-2 xl:grid-cols-[1fr,1fr]">
            <DailyStreak dailyStreak={questData?.daily_streak} />
            <Refs />
          </div>
        </div>
        <div className="grid grid-cols-1 items-center justify-center gap-2 xl:grid-cols-[1fr,1fr]">
          <HopiumCard />
          <Quests tasks={questData?.tasks} />
          {/* <CompletedMissions /> */}
        </div>
        <Inventory />
      </div>
    </CenteredContentLayout>
  );
}
